import React, { useCallback, useRef, useState, useEffect } from 'react'
import axios from 'axios'
import { AiOutlineCloudDownload, AiOutlineFilePdf } from 'react-icons/ai'
import { useSelector } from 'react-redux'
import ContentLoader from 'react-content-loader'
import ReactToPrint, { useReactToPrint } from 'react-to-print'
import fetchProgress from 'fetch-progress'
import CryptoJS from 'crypto-js'
import { toast } from 'react-toastify'

import ModalTeacher from './modalTeacher'

import {
  Container,
  ImageWrapper,
  ImageContainer,
  ContentWrapper,
  DescriptionLesson,
  TeacherContent,
  Wrapper,
  ButtonContainerDesk,
  ButtonsWrapper,
  MenuDropdown,
} from './styles'

import Direcao from '../../../../assets/logos/direcao-square.png'
import { useTracking } from 'react-tracking'
import { RootState } from '../../../../store/modules/rootReducer'
import { WrapperContainer } from '../../../../components/ModalFreemium/styles'
import ModalFreemium from '../../../../components/ModalFreemium'
import { TrackingSchemaTypes } from '../../../../tracking'
import { learningApi } from '../../../../services/api'
import Modal from '../../../../components/Modal'

interface BannerProps {
  course: any
  module: any
  lesson: any
  chapter: any
  object?: any
  professores: any[]
  contents: any[]
  loading: boolean
  types: any[]
}

const Banner: React.FC<BannerProps> = ({
  course,
  module,
  lesson,
  chapter,
  object,
  professores,
  contents,
  loading,
  types,
}) => {
  const token = localStorage.getItem('token')
  const { profile } = useSelector((state: RootState) => state.student)
  const { isDarkMode } = useSelector((state: RootState) => state.theme)
  const [open, setOpen] = useState<boolean>(false)
  const [printExcert, setPrintExcert] = useState(false)
  const [src, setSrc] = useState<string>('')
  const [openModal, setOpenModal] = useState<boolean>(false)
  const [openModalTeacher, setOpenModalTeacher] = useState<boolean>(false)
  const [downloading, setDownloading] = useState<boolean>(false)
  const [progress, setProgress] = useState<any>({ percentage: 0 } as any)
  const [openModalFreemium, setOpenModalFreemium] = useState<boolean>(false)

  const buttonRef: any = useRef()
  const excertRef = useRef<HTMLDivElement>()
  const { trackEvent } = useTracking()

  const TEXT_MAX_LENGTH = 98

  const handlePrint = useReactToPrint({
    content: () => excertRef.current,
    onAfterPrint: () => setPrintExcert(false),
  })

  useEffect(() => {
    if (printExcert) {
      handlePrint()
    }
  }, [handlePrint, printExcert])

  useEffect(() => {
    let excerto: any

    if (document.getElementsByClassName('excerto')) {
      excerto = document.getElementsByClassName('excerto')
      for (let i = 0; i < excerto?.length; i++) {
        excerto[i].addEventListener('click', function (event: any) {
          if (event.target.tagName === 'IMG') {
            setSrc(event.target.src)
            setOpenModal(true)
          }
        })
      }
    }
  }, [])

  const handlerMenuOpen = useCallback(() => {
    setOpen(!open)
  }, [setOpen, open])

  const downloadPDFFile = (name: string, blob: Blob) => {
    const fileName = `${name}.pdf`
    const url = URL.createObjectURL(blob)

    const link = document.createElement('a')
    link.download = fileName
    link.href = url

    link.dispatchEvent(
      new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    )

    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(url)
      link.remove()
    }, 100)
  }

  const RenderModalFreemium = useCallback(() => {
    const moduleInfos = {
      _id: module._id,
      name: module.name,
      icon: module.icon ?? Direcao,
      discount: module.discount,
      permanentLink: module.permanentLink,
      qtd_videos: module.total.video?.amount,
      qtd_pdf: module.total.excerto?.amount,
    }

    const courseInfos = {
      _id: course._id,
      name: course.name,
      icon: course.icon ?? Direcao,
      discount: course.discount,
      permanentLink: course.permanentLink,
      qtd_videos: course.totalCourse.videos?.amount,
      qtd_pdf: course.totalCourse.excertos?.amount,
    }

    return (
      <WrapperContainer>
        <ModalFreemium
          module={moduleInfos}
          course={courseInfos}
          subscription={course?.isFreemium && course?.isSubscription}
          setOpenModal={setOpenModalFreemium}
        />
      </WrapperContainer>
    )
  }, [course, module])

  const downloadLessonPDF = async () => {
    if (course?.isFreemium) {
      return RenderModalFreemium()
    }

    trackEvent({
      event: TrackingSchemaTypes.DownloadContent,
      properties: {
        Id: profile?._id,
        Nome: profile?.name,
        Email: profile?.email,
        Produto: course.name,
        Curso: course.name,
        Categoria: course?.isSubscription ? 'Assinatura' : course?.isCourse ? 'Curso' : 'Módulo',
        Carreira: course?.career,
        Instituicao: course?.publicTenderInstitution,
        Modulo: module.name,
        Aula: lesson.name,
        Capitulo: chapter.name,
        Objeto: object?.name ?? contents.find((c) => c.type === 'excerto')?.name,
        ObjetoId: object?._id ?? contents.find((c) => c.type === 'excerto')?._id,
        Professores: professores.map((p) => ({ Nome: p.name, Id: p._id })),
        Formato: 'Texto',
        Tipo: 'Completo',
        Atual: (lesson?.order || 0) + 1,
        Inicio: lesson?.isFirst,
        Fim: lesson?.isLast,
      },
    })

    setDownloading(true)
    learningApi
      .post(
        `/content/lesson-pdf`,
        {
          course: course._id,
          module: module._id,
          lesson: lesson._id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'text',
        }
      )
      .then(async (resp) => {
        if (resp.status !== 200) return
        if (resp.data === '') {
          toast.info('O PDF está sendo gerado. Tente novamente em instantes.')
          return
        }
        const pdfReq = await axios.get(resp.data, {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            setProgress({ percentage } as any)
          },
        })
        if (pdfReq.status !== 200) return
        downloadPDFFile(lesson.name, pdfReq.data)
      })
      .catch((err) => console.error(err))
      .finally(() => setDownloading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }

  const downloadVideo = useCallback(() => {
    try {
      const selected = object ? contents.find((c) => c._id === object._id) : contents[0]

      trackEvent({
        event: TrackingSchemaTypes.DownloadContent,
        properties: {
          Id: profile?._id,
          Nome: profile?.name,
          Email: profile?.email,
          Produto: course.name,
          Curso: course.name,
          Categoria: course?.isSubscription ? 'Assinatura' : course?.isCourse ? 'Curso' : 'Módulo',
          Carreira: course?.career,
          Instituicao: course?.publicTenderInstitution,
          Modulo: module.name,
          Aula: lesson.name,
          Capitulo: chapter.name,
          Objeto: object?.name ?? contents.find((c) => c.type === 'excerto')?.name,
          ObjetoId: object?._id ?? contents.find((c) => c.type === 'excerto')?._id,
          Professores: professores.map((p) => ({ Nome: p.name, Id: p._id })),
          Formato: 'Vídeo',
          Tipo: 'Individual',
          Atual: (lesson?.order || 0) + 1,
          Inicio: lesson?.isFirst,
          Fim: lesson?.isLast,
        },
      })

      const bytes = CryptoJS.AES.decrypt(selected.media.hash, token)
      const url = bytes.toString(CryptoJS.enc.Utf8)
      const fileName = `${profile.document} - ${profile.name} - ${selected.name}.mp4`

      setDownloading(true)
      fetch(
        url
        /*, { mode: "no-cors" }*/
      )
        .then(
          fetchProgress({
            onProgress(progress) {
              setProgress(progress)
            },
            onError(err) {
              throw err
            },
          })
        )
        .then((result) => {
          if (result.status !== 200) {
            throw new Error('Bad server response')
          }
          return result.blob()
        })
        .then((data) => {
          const url = window.URL.createObjectURL(data),
            anchor = document.createElement('a')

          anchor.href = url
          anchor.download = fileName
          anchor.click()

          window.URL.revokeObjectURL(url)

          setDownloading(false)
          setProgress({ percentage: 0 })
        })
        .catch((error) => {
          if (error?.response?.status === 401) return
          console.error(error)
          setDownloading(false)
          setProgress({ percentage: 0 })
          toast.error('Erro ao preparar arquivo para download!')
        })
    } catch (err) {
      if (err?.response?.status === 401) return
      console.error(err)
      setDownloading(false)
      setProgress({ percentage: 0 })
      toast.error('Falha ao processar arquivo!')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [object, contents, profile, token])

  const downloadChapterPDF = useCallback(() => {
    setDownloading(true)

    trackEvent({
      event: TrackingSchemaTypes.DownloadContent,
      properties: {
        Id: profile?._id,
        Nome: profile?.name,
        Email: profile?.email,
        Produto: course.name, // ARRUMAR PARA TER O NOME DA ASSINATURA !
        Curso: course.name,
        Categoria: course?.isSubscription ? 'Assinatura' : course?.isCourse ? 'Curso' : 'Módulo',
        Carreira: course?.career,
        Instituicao: course?.publicTenderInstitution,
        Modulo: module.name,
        Aula: lesson.name,
        Capitulo: chapter.name,
        Objeto: object?.name ?? contents.find((c) => c.type === 'excerto')?.name,
        ObjetoId: object?._id ?? contents.find((c) => c.type === 'excerto')?._id,
        Professores: professores.map((p) => ({ Nome: p.name, Id: p._id })),
        Formato: 'Texto',
        Tipo: 'Individual',
        Atual: (lesson?.order || 0) + 1,
        Inicio: lesson?.isFirst,
        Fim: lesson?.isLast,
      },
    })

    learningApi
      .post(
        `/content/chapter-pdf`,
        {
          course: course._id,
          module: module._id,
          lesson: lesson._id,
          chapter: chapter._id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'text',
        }
      )
      .then(async (resp) => {
        if (resp.status !== 200) return
        if (resp.data === '') {
          toast.info('O PDF está sendo gerado. Tente novamente em instantes.')
          return
        }
        const pdfReq = await axios.get(resp.data, {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            const percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total)
            setProgress({ percentage } as any)
          },
        })
        if (pdfReq.status !== 200) return
        downloadPDFFile(chapter.name, pdfReq.data)
      })
      .catch((err) => console.error(err))
      .finally(() => {
        setDownloading(false)
        setProgress({ percentage: 0 } as any)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course, module?._id, chapter?._id, chapter?.name, lesson?._id, token])

  window.addEventListener(
    'click',
    useCallback(
      (event) => {
        if (buttonRef.current && !buttonRef.current.contains(event.target)) {
          setOpen(false)
        }
      },
      [buttonRef, setOpen]
    )
  )

  const LoaderProps = {
    speed: 2,
    backgroundColor: isDarkMode ? '#222222' : '#bababa',
    foregroundColor: isDarkMode ? '#2b2b2b' : '#dedede',
  }

  return (
    <Container>
      <Wrapper>
        <ImageContainer>
          {loading ? (
            <ContentLoader width={55} height={55} viewBox={'0 0 55 55'} {...LoaderProps}>
              <rect x="0" y="0" rx="6" ry="6" width="55" height="55" />
            </ContentLoader>
          ) : (
            <ImageWrapper>
              <img src={course?.icon || Direcao} alt="Logo curso" />
            </ImageWrapper>
          )}
        </ImageContainer>
        <ContentWrapper>
          <DescriptionLesson>
            {loading ? (
              <>
                <h1>
                  <ContentLoader width={288} height={100} viewBox={'0 0 288 100'} {...LoaderProps}>
                    <rect x="0" y="40" rx="3" ry="3" width="288" height="24" />
                    <rect x="0" y="70" rx="3" ry="3" width="180" height="24" />
                  </ContentLoader>
                </h1>
              </>
            ) : (
              <>
                <h1>
                  {lesson?.name?.length < TEXT_MAX_LENGTH
                    ? lesson?.name
                    : lesson?.name?.substring(0, TEXT_MAX_LENGTH) + '...'}
                </h1>
                <h2>
                  {chapter?.name?.length < 80
                    ? chapter?.name
                    : chapter?.name?.substring(0, 80) + '...'}
                </h2>
              </>
            )}
          </DescriptionLesson>
          <TeacherContent>
            <div className="teacherInfo">
              {loading ? (
                <ContentLoader width={40} height={40} viewBox={'0 0 40 40'} {...LoaderProps}>
                  <circle cx="16" cy="16" r="16" />
                </ContentLoader>
              ) : (
                <div className="photoContainer">
                  {(professores || [])
                    .filter((item, idx) => idx < 2)
                    .map((item, idx) => (
                      <div key={idx} className="photoWrapper">
                        <img
                          src={
                            item?.image ??
                            `https://ui-avatars.com/api/?name=${item.name}&=rounded=true&background=ff6600&color=FFF`
                          }
                          alt={item.name}
                        />
                      </div>
                    ))}
                </div>
              )}
              <p className="teacher_name">
                {(professores || [])
                  .filter((item, idx) => idx < 2)
                  .map((item) => ' Prof. ' + item.name)
                  .toString()
                  .trim()}
                {professores?.length < 2 ? null : '...'}
              </p>
            </div>
            {professores?.length < 2 ? null : (
              <button onClick={() => setOpenModalTeacher(true)}>Ver todos</button>
            )}
            {openModalTeacher ? (
              <ModalTeacher professores={professores} close={() => setOpenModalTeacher(false)} />
            ) : null}
          </TeacherContent>
        </ContentWrapper>
        {!loading && (
          <ButtonContainerDesk>
            <ButtonsWrapper ref={buttonRef}>
              {downloading ? (
                <button disabled>{`Baixando... ${
                  progress ? progress.percentage + '%' : ''
                }`}</button>
              ) : (
                <>
                  <button id="lesson-dropdown-toggle" onClick={handlerMenuOpen}>
                    <AiOutlineCloudDownload color={'#FFF'} size={16} /> Baixar
                  </button>
                  <MenuDropdown style={{ display: open ? 'block' : 'none' }} id="lesson-dropdown">
                    <ul>
                      {(types || []).some((t) => t === 'excerto') && (
                        <>
                          <li
                            onClick={() =>
                              course?.isFreemium ? setOpenModalFreemium(true) : downloadLessonPDF()
                            }
                          >
                            <AiOutlineFilePdf style={{ marginRight: '0.5rem' }} /> Baixar aula
                            completa
                          </li>
                          {/* <li
                            onClick={() =>
                              course?.isFreemium ? setOpenModalFreemium(true) : downloadChapterPDF()
                            }
                          >
                            <AiOutlineFilePdf style={{ marginRight: '0.5rem' }} /> Baixar capítulo
                          </li> */}
                        </>
                      )}
                      {(types || []).some((t) => t === 'video') && (
                        <li
                          onClick={() =>
                            course?.isFreemium ? setOpenModalFreemium(true) : downloadVideo()
                          }
                        >
                          <AiOutlineCloudDownload style={{ marginRight: '0.5rem' }} /> Baixar vídeo
                        </li>
                      )}
                    </ul>
                  </MenuDropdown>
                </>
              )}
            </ButtonsWrapper>
          </ButtonContainerDesk>
        )}
      </Wrapper>

      <ReactToPrint
        content={() => excertRef.current}
        copyStyles={false}
        pageStyle={() => {
          return `@page { margin: 2rem !important; width: 100%; }`
        }}
      />
      <Modal onClose={() => setOpenModal(false)} open={openModal}>
        <div className="imgLesson">
          <img
            src={src}
            alt="Imagem da lição"
            style={{
              width: 'auto',
              objectFit: 'contain',
              display: 'flex',
              marginBottom: '1rem',
            }}
          />
        </div>
      </Modal>
      {openModalFreemium && RenderModalFreemium()}
    </Container>
  )
}

export default Banner
